import { JsonObject } from 'core/types';

export class ImpersonationUser {
  public name: string;
  public fullName: string;

  constructor(json: JsonObject) {
    this.name = json.username;
    this.fullName = json.fullName;
  }
}
